export const NAV_ITEMS = [
  { path: '/', label: 'Calculator' },
  { path: '/dosages', label: 'Suggested Dosages' },
  { path: '/regimens', label: 'Regimens' },
  { path: '/intake', label: 'Intake Records' },
  { path: '/plans', label: 'Current Plans' },
  { path: '/calendar', label: 'Calendar' },
] as const;